/* Enable Mobile Active State */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeGenericEnableMobileActiveState() {
    
    /* If Mobile */
    if ( jQuery( 'html' ).hasClass( 'platform-mobile' ) ) {
        
        /* Disable Touchstart */
        document.addEventListener( 'touchstart' , function() {} , false );
    
    }
    
}

/* Disable Mobile Telephone On Desktop */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeGenericDisableMobileTelephoneOnDesktop() {
    
    /* If Desktop */
    if ( jQuery( 'html' ).hasClass( 'platform-desktop' ) ) {
        
        /* Disable Click */
        jQuery( 'a[href^="tel"]' ).on( 'click' , function( event ) {
            event.preventDefault();
        });
    
    }

}

/* Open External Links In New Window */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeGenericExternalLinks() {

    jQuery( 'a[href^="http://"]'  ).not( '[href*="'+document.domain+'"]' ).attr( 'target' , '_blank' );
    jQuery( 'a[href^="https://"]' ).not( '[href*="'+document.domain+'"]' ).attr( 'target' , '_blank' );
    jQuery( 'a[href$=".pdf"]' ).attr( 'target' , '_blank' );

}

/* List Bullet Color */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeGenericListBulletColor() {

    /* List In Content */
    jQuery( '.content ul > li, .content ol > li' ).wrapInner( '<span></span>' );

}

/* Mobile Menu */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeGenericMobileMenu() {
    
    /* Click */
    jQuery( 'header > div > div > #header-menu' ).on( 'click' , function( event ) {
        
        /* Stop Click */
        event.preventDefault();
        
        /* Show / Hide Menu */
        jQuery( 'header' ).toggleClass( 'show-menu' );
    
    });
    
    /* Set Resize */
    jQuery(window).on( 'resize.navigation' , function() {
    
        /* If Button Hidden */
        if ( ( jQuery( 'nav > div > div > a' ).css( 'display' ) === 'block' ) && jQuery( 'header' ).hasClass( 'show-menu' ) ) {

            /* Hide Navigation */
            jQuery( 'header' ).removeClass( 'show-menu' );
        
        }
    
    });

}

/* Open / Close Section */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeGenericOpenCloseSection() {

    /* Click */
    jQuery( '.form-button-open-close' ).on( 'click' , function( event ) {
        
        /* Stop Click */
        event.preventDefault();
    
        /* Get Section */
        var section = jQuery( this ).parent( 'section' ).first();
        
        /* Show / Hide Content */
        section.toggleClass( 'section-open' );
    
    });

}

/* Generic Init */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeGenericInit() {

    /* Enable Mobile Active State */
    ipcrimeGenericEnableMobileActiveState();
    
    /* Disable Mobile Telephone On Desktop */
    ipcrimeGenericDisableMobileTelephoneOnDesktop();

    /* Open External Links In New Window */
    ipcrimeGenericExternalLinks();
    
    /* List Bullet Color */
    ipcrimeGenericListBulletColor();
    
    /* Mobile Menu */
    ipcrimeGenericMobileMenu();
    
    /* Open / Close Section */
    ipcrimeGenericOpenCloseSection();
    
    /* Cycle Init */
    ipcrimeCycleInit();

}